module.exports = __webpack_public_path__ + "img/space1.abeee010.jpg";